/** Change product copy without changing protocol names or translation message IDs. */
export function brandText(text: string, name: string): string {
  return text.replaceAll("Rakazo", name);
}

/** Lingui catalogs contain nested arrays and plural/select branches. Keep their keys intact. */
export function brandMessages<T>(messages: T, name: string): T {
  const visit = (value: unknown): unknown => {
    if (typeof value === "string") return brandText(value, name);
    if (Array.isArray(value)) return value.map(visit);
    if (value && typeof value === "object") {
      return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, visit(item)]));
    }
    return value;
  };
  return Object.fromEntries(
    Object.entries(messages as Record<string, unknown>).map(([key, value]) => [key, visit(value)]),
  ) as T;
}
